import React from 'react';
import { FaCheckCircle, FaTimes } from 'react-icons/fa';
import './BooleanView.scss';

interface IChangedValueItemProps {
    is: boolean;
}

export const BooleanView: React.FC<IChangedValueItemProps> = ({ is }) => {
    return is ? <FaCheckCircle color={'#23B383'} /> : <FaTimes color={'#EF4444'} />;
};
